// Should stay in sync with the notificationTypes.mjs

export const TOAST_NOTIFICATION_TYPES = {
  EVENT_COMMENT_ADDED: 0,
  EVENT_COMMENT_EDITED: 1,
  EVENT_MOVED_TO_READY_TO_DELIVER: 2,
  EVENT_CONFIRM_ASSIGNMENT: 3,
  EVENT_DECLINE_ASSIGNMENT: 4,
  EVENT_SUBMITTED: 5,
  EVENT_ATL_OBSERVER_ASSIGNED: 6,
  EVENT_ATL_OBSERVER_UNASSIGNED: 7,
  EVENT_ATL_OBSERVABLE_UNASSIGNED: 8,
  INVALID_FILE: 9,
  EVENT_ATM_OBSERVER_ASSIGNED: 10,
  USER_ASSIGNED_TO_FUTURE_EVENT: 11,
  USER_INVITED_TO_FUTURE_EVENT: 12,
  ORG_UNIT_DEACTIVATED_AND_EVENT_GOT_REMOVED: 13,
  ORG_UNIT_DEACTIVATED_AND_REMOVED_FROM_MULTI_SITE_EVENT: 14,
  OBSERVATION_REPORT_SUBMITTED: 15
};
